export type DomainArea = string;

export interface DomainSelectorAgentConfig {
  /** Agent name as it appears in the manifest (case-sensitive). */
  agentName: string;
  /** Domain choices shown in the header selector. */
  domains: readonly DomainArea[];
  /** Default selected domain when agent is selected/reset. */
  defaultDomain: DomainArea | null;
  /** Optional list of domain choices that are temporarily disabled in UI. */
  disabledDomains?: readonly DomainArea[];
}

const DEFAULT_DOMAINS: readonly DomainArea[] = ['DOA', 'OTC'];

/**
 * Agents that require domain selection/tagging.
 * Add new agent names here to enable the selector for them.
 */
export const DOMAIN_SELECTOR_AGENT_CONFIGS: readonly DomainSelectorAgentConfig[] = [
  {
    agentName: 'OtisBot',
    domains: DEFAULT_DOMAINS,
    defaultDomain: 'OTC',
    disabledDomains: ['DOA'],
  },
  {
    agentName: 'RichardBot',
    domains: ['FC', 'RTR'],
    defaultDomain: '',
  },
];

export const getDomainSelectorConfig = (
  agentName: string | undefined,
): DomainSelectorAgentConfig | undefined =>
  DOMAIN_SELECTOR_AGENT_CONFIGS.find((config) => config.agentName === agentName);

export const hasDomainSelector = (agentName: string | undefined): boolean =>
  getDomainSelectorConfig(agentName) != null;
